module.exports = __webpack_public_path__ + "img/13.c74d0d92.png";